/**
 * A no-operation function that returns `undefined` regardless of the
 * arguments it receives.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.noop(object) === undefined;
 * // => true
 */
function noop() {
  // No operation performed.
}

export default noop;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/noop.js
// module id = null
// module chunks = 